<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="请输入单据号或备注" v-model="queryParam.kw"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单据日期">
              <a-range-picker @change="dateChange" :defaultValue="[moment(queryParam.s_date, format), moment(queryParam.e_date, format)]"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="客户"
            >
              <a-input-search
                placeholder="请选择客户"
                @change="customerTextChange"
                @search="onCustomerSearch"
                @click="onCustomerSearch"
                v-model="customerName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize="20"
      :columns="columns"
      :data="loadData"
      bordered
      rowKey="id"
    >
      <span slot="action" slot-scope="text, record">
        <router-link :to="{ path: '/storage/other/out/edit/'+record.id }">查看</router-link>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm placement="topLeft" title="确定要删除此出库单吗?删除后相关库存数据同时删除！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
                <a href="#">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <CustomerModal :visible="customerModalVisible" @handleCancel="customerModalCancel" @handleOk="customerModalOk"></CustomerModal>
  </a-card>
</template>
<script>
import moment from 'moment'
import STable from '@/components/table/'
import CustomerModal from '@/components/Customer/Modal'
import { getStorageOutList, deleteStorageOut } from '@/api/bill'
import { CODE_FAIL } from '@/store/mutation-types'

export default {
  components: {
    STable,
    CustomerModal
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      customerModalVisible: false,
      // 查询参数
      queryParam: {
        s_date: '',
        e_date: '',
        contactId: '',
        kw: ''
      },

      customerName: '',
      // 表头
      columns: [
        {
          title: '单据日期',
          dataIndex: 'billDate',
          className: 'text-center'
        },
        {
          title: '单据编号',
          dataIndex: 'billNo',
          className: 'text-center'
        },
        {
          title: '客户',
          dataIndex: 'customer.name',
          className: 'text-center'
        },
        {
          title: '数量',
          className: 'text-right',
          dataIndex: 'totalQty'
        },
        {
          title: '金额',
          className: 'text-right',
          dataIndex: 'totalAmount'
        },
        {
          title: '备注',
          dataIndex: 'note',
          className: 'text-center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          className: 'text-center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getStorageOutList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.queryParam.s_date = moment().subtract(7, 'days').format(this.format)
    this.queryParam.e_date = moment().format(this.format)
  },
  methods: {
    moment,
    customerTextChange (e) {
      if (!e.data) {
        this.queryParam.contactId = ''
      }
    },
    customerModalCancel () {
      this.customerModalVisible = false
    },
    customerModalOk (selectedRows) {
      this.customerModalVisible = false
      if (selectedRows.length > 0) {
        const ids = []
        const names = []
        selectedRows.forEach(function (item) {
          ids.push(item.id)
          names.push(item.name)
        })
        this.queryParam.contactId = ids.join(',')
        this.customerName = names.join(',')
      }
    },
    onCustomerSearch () {
      this.customerModalVisible = true
    },
    dateChange (date, dateString) {
      this.queryParam.s_date = dateString[0]
      this.queryParam.e_date = dateString[1]
    },
    handleAdd () {
      this.$router.push({ name: 'StorageOtherOut' })
    },

    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    deleteConfirm (id) {
      deleteStorageOut({ id: id }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          this.reloadTable()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  watch: {
  }
}
</script>
<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>
